module.exports = __webpack_public_path__ + "static/media/Target File Finded.ab3b02c2.svg";